// extracted by mini-css-extract-plugin
export default {"wrapper":"tC","order_date":"uC","loading":"vC","banner":"wC","title":"xC","subtitle":"yC","fsa":"zC"};
    if(module.hot) {
      // 1738836196767
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  